import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import { throwResponseError } from '@/utils/index';

export interface GenerateReceiptPdfProps {
  /** Id of the associated receipt */
  receiptIds: number[];
}

const generateReceiptPdf = async ({
  receiptIds = [],
}: GenerateReceiptPdfProps) => {
  const queryString = qs.stringify(
    { receipt_ids: receiptIds },
    { arrayFormat: 'brackets' }
  );
  const url = `/api/v5/receipts_pdf?${queryString}`;

  const res = await fetch(url.toString());
  if (res.status === 200) {
    return res.json();
  }
  if (res.status === 202) {
    throw new Error('Pdf not ready');
  } else {
    throwResponseError('Error generating pdf', res);
  }

  return null;
};

export function useReceiptPdf(receiptIds: number[]) {
  return useQuery<string, Error>({
    queryKey: ['receiptPdf', receiptIds],
    queryFn: async () => {
      const pdf = await generateReceiptPdf({
        receiptIds,
      });

      return pdf.url;
    },

    enabled: false,
    retry: (failureCount, error) => {
      if (error.message.match(/Pdf not ready/)) return true;
      return false;
    },
  });
}
